import React from "react";
import UiContext from "../../context/UiContext";

import Dialog from "../Dialog";
import { InfoDialog } from "./InfoDialog";
import { EntryDialog } from "./EntryDialog";

const DialogController: React.FC = () => {
  const { state, closeDialog } = React.useContext(UiContext);

  return (
    <Dialog
      isOpen={state.dialog.isOpen}
      name={state.dialog.name || "No name"}
      onClose={closeDialog}
    >
      <>{state.dialog?.name === "info" && <InfoDialog />}</>
      <>
        {state.dialog?.name === "entry" && state.dialog?.entryId && (
          <EntryDialog id={state.dialog?.entryId} onClose={closeDialog} />
        )}
      </>
    </Dialog>
  );
};

export default DialogController;
